module.exports = __webpack_public_path__ + "img/ico-menu-point.9292ac30.svg";